import config from "../../config";
const baseUrl = config.baseUrl;

export  const MedicineUrls = {

  MEDICINE_ADD: baseUrl + "/patientMedicine",
  MEDICINE_EDIT: baseUrl + "/patientMedicine",
  MEDICINE_LIST: baseUrl + "/patientMedicine",
  MEDICINE_DELETE: baseUrl + "/patientMedicine",
  MEDICINE_GETBYID: baseUrl + "/patientMedicine",
  MEDICINE_DROPDOWN: baseUrl + "/patients/dropdown",
  MEDICINE_ROLLBACK: baseUrl + "/patientMedicine",
  MEDICINE_DELETE_HARD: baseUrl + "/patientMedicine",
  MEDICINE_DIAGNOSIS_UPDATE:baseUrl+"/medicineDiagnosis"
}; 